export const PAYMENT_ENABLED = process.env.REACT_APP_PAYMENT_ENABLED === 'true';
